module.exports = __webpack_public_path__ + "img/user-gift.8b990377.svg";